//React Components and Hooks
import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
//Material UI functions
import { makeStyles } from "@mui/styles";
//Material UI Components
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableSortLabel from "@mui/material/TableSortLabel";
// Custom Components
import Cell from "./Cell";

const UbilHeader = (props) => {
  const { columns } = props;
  return (
    <TableRow>
      {columns
        ? columns.map((column, index) => {
            const isSortable = column.sortable && column.onSort;
            return (
              <TableCell 
                key={index}
                sx={{
                  cursor: isSortable ? 'pointer' : 'default',
                  userSelect: 'none',
                }}
                onClick={isSortable ? column.onSort : undefined}
              >
                {isSortable ? (
                  <TableSortLabel
                    active={column.sortDirection !== false}
                    direction={column.sortDirection || 'asc'}
                    sx={{
                      '& .MuiTableSortLabel-icon': {
                        opacity: column.sortDirection !== false ? 1 : 0.5,
                        fontSize: '1.2rem',
                        color: column.sortDirection !== false ? 'primary.main' : 'text.secondary',
                      },
                      '&:hover .MuiTableSortLabel-icon': {
                        opacity: 1,
                        color: 'primary.main',
                      },
                      '&.Mui-active': {
                        color: 'primary.main',
                        fontWeight: 600,
                      },
                    }}
                  >
                    {column.name}
                  </TableSortLabel>
                ) : (
                  column.name
                )}
              </TableCell>
            );
          })
        : ""}
    </TableRow>
  );
};
export default UbilHeader;
